// frontend/src/pages/AdminDashboard.js
import React, { useState } from 'react';
import ChatSandbox from '../components/ChatSandbox';
import ManageChatters from '../components/ManageChatters';
import ManageModels from '../components/ManageModels';
import ManageAccounts from '../components/ManageAccounts';
import Conversations from '../components/Conversations';
import ManageAdspower from '../components/ManageAdspower';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function AdminDashboard() {
  // This was missing:
  const [activeTab, setActiveTab] = useState('sandbox'); // 'sandbox' or 'chatters'
  
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
      await logout();
      navigate('/login');
  };

  return (
    <div style={{ display: 'flex', height: '100vh', flexDirection: 'column' }}>
      {/* Header */}
      <div style={{ background: '#333', padding: '10px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: 'white' }}>
          <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
              <h3>🛡️ SHIELD Admin</h3>
              <button 
                  onClick={() => setActiveTab('sandbox')} 
                  style={{ background: 'transparent', border: 'none', color: activeTab === 'sandbox' ? '#fff' : '#888', cursor: 'pointer', borderBottom: activeTab === 'sandbox' ? '2px solid #007acc' : 'none' }}>
                  Chat Sandbox
              </button>
              <button 
                  onClick={() => setActiveTab('chatters')} 
                  style={{ background: 'transparent', border: 'none', color: activeTab === 'chatters' ? '#fff' : '#888', cursor: 'pointer', borderBottom: activeTab === 'chatters' ? '2px solid #007acc' : 'none' }}>
                  Chatters
              </button>
              <button 
                  onClick={() => setActiveTab('models')} 
                  style={{ background: 'transparent', border: 'none', color: activeTab === 'models' ? '#fff' : '#888', cursor: 'pointer', borderBottom: activeTab === 'models' ? '2px solid #007acc' : 'none' }}>
                  Groups (IDs)
              </button>
              <button 
                  onClick={() => setActiveTab('accounts')} 
                  style={{ background: 'transparent', border: 'none', color: activeTab === 'accounts' ? '#fff' : '#888', cursor: 'pointer', borderBottom: activeTab === 'accounts' ? '2px solid #007acc' : 'none' }}>
                  Accounts
              </button>
              <button 
                  onClick={() => setActiveTab('conversations')} 
                  style={{ background: 'transparent', border: 'none', color: activeTab === 'conversations' ? '#fff' : '#888', cursor: 'pointer', borderBottom: activeTab === 'conversations' ? '2px solid #007acc' : 'none' }}>
                  Conversations
              </button>
              <button 
                  onClick={() => setActiveTab('adspower')} 
                  style={{ background: 'transparent', border: 'none', color: activeTab === 'adspower' ? '#fff' : '#888', cursor: 'pointer', borderBottom: activeTab === 'adspower' ? '2px solid #007acc' : 'none' }}>
                  Adspower
              </button>
          </div>
          <button onClick={handleLogout} style={{ background: '#a31515', color: 'white', border: 'none', padding: '5px 10px' }}>Logout</button>
      </div>

      {/* Main Content Area */}
      <div style={{ flex: 1, overflow: 'hidden', position: 'relative' }}>
          {activeTab === 'sandbox' ? (
              <div style={{ height: '100%', width: '100%' }}>
                  <ChatSandbox />
              </div>
          ) : activeTab === 'chatters' ? (
              <div style={{ height: '100%', overflowY: 'auto' }}>
                  <ManageChatters />
              </div>
          ) : activeTab === 'models' ? (
              <div style={{ height: '100%', overflowY: 'auto' }}>
                  <ManageModels />
              </div>
          ) : activeTab === 'conversations' ? (
             <div style={{ height: '100%', overflowY: 'hidden' }}>
                  <Conversations role="admin" />
             </div>
          ) : activeTab === 'adspower' ? (
              <div style={{ height: '100%', overflowY: 'auto' }}>
                  <ManageAdspower />
              </div>
          ) : (
              <div style={{ height: '100%', overflowY: 'auto' }}>
                  <ManageAccounts />
              </div>
          )}
      </div>
    </div>
  );
}